import ChangePassword from './ChangePassword.vue';

export default ChangePassword;


// WEBPACK FOOTER //
// ./src/components/ChangePassword/index.js